import { Grid, Typography } from "@mui/material";
import React from "react";
import { GetAllLoanTemplatesResponse } from "../../models/loanTemplate.model";

type Props = {
  item: GetAllLoanTemplatesResponse;
};

export default function SpecificationsPlan({ item }: Props) {
  return (
    <Grid
      container
      sx={{
        p: 1,
        // m: 1,
        textAlign: { xs: "center", md: "right" },
        direction: "rtl",
        flexDirection: {
          xs: "column",
          md: "row",
        },
      }}
    >
      <Grid
        item
        xs={12}
        md={3}
        sx={{
          pr: 2,
          borderLeft: {
            md: "none",
          },
        }}
      >
        <Typography color="#9AAFC4" mt={1}>
          نوع بازپرداخت:{" "}
          <span style={{ color: "#34495E" }}>{item.repaymentTypeTitle}</span>
        </Typography>
        <Typography color="#9AAFC4" mt={1}>
          کمترین سن متقاضی:{" "}
          <span style={{ color: "#34495E" }}>{item.minAgeRestriction}</span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{
          pr: 2,
          borderRight: {
            md: "1px solid #C1C7CB",
          },
        }}
      >
        <Typography color="#9AAFC4" mt={1}>
          تاریخ انقضای طرح:{" "}
          <span style={{ color: "#34495E" }}>
            {item.loanTemplateExpireDatePersian}
          </span>
        </Typography>
        <Typography color="#9AAFC4" mt={1}>
          بیشترین سن متقاضی:{" "}
          <span style={{ color: "#34495E" }}>{item.maxAgeRestriction}</span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{
          pr: 2,
          borderRight: {
            md: "1px solid #C1C7CB",
          },
        }}
      >
        <Typography color="#9AAFC4" mt={1}>
          نوع طرح:{" "}
          <span style={{ color: "#34495E" }}>
            {item.isLoanTemplatePublic
              ? "عمومی"
              : `طرح اختصاصی ${item.specialStoreTitle}`}
          </span>
        </Typography>
        <Typography color="#9AAFC4" mt={1}>
          درصد توان بازپرداخت:{" "}
          <span style={{ color: "#34495E" }}>
            {item.repaymentPowerPercentage}
          </span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={3}
        sx={{
          pr: 2,
          borderRight: {
            md: "1px solid #C1C7CB",
          },
        }}
      >
        <Typography color="#9AAFC4" mt={1}>
          روش پرداخت هزینه اشتراک:{" "}
          <span style={{ color: "#34495E" }}>{item.feePaymentTypeTitle}</span>
        </Typography>
        <Typography color="#9AAFC4" mt={1}>
          درصد چک ضمانت:{" "}
          <span style={{ color: "#34495E" }}>{item.guarantyPercentage}</span>
        </Typography>
      </Grid>
    </Grid>
  );
}
